import React from 'react';
import logoMark from '../assets/brand/logo-mark.png';
import wordartLogo from '../assets/brand/spud_wordart_logo.png';

/**
 * SpudClub logo lockup: potato mark + wordart image.
 */
const BrandLogo = ({ className = '' }) => (
    <div className={`sc-logo ${className}`.trim()} aria-label="SpudClub">
        <img
            src={logoMark}
            alt=""
            className="sc-logo__mark"
            width={138}
            height={138}
            decoding="async"
        />
        <img
            src={wordartLogo}
            alt=""
            className="sc-logo__wordmark"
            width={693}
            height={537}
            decoding="async"
        />
    </div>
);

export default BrandLogo;
